// extracted by mini-css-extract-plugin
export var banner = "_f1-0";
export var closeButton = "_f1-2";
export var greenCheckmark = "_f1-3";
export var hereLink = "_f1-4";
export var titleIcon = "_f1-1";